import { Badge } from '@/components/ui/badge';
import { OriginalTeacherIssue, OriginalTeacherIssueLabelMap } from '@airreading/common/data';

interface OriginalTeacherIssueTagProps {
  issue: OriginalTeacherIssue | null;
}

export function OriginalTeacherIssueTag({ issue }: OriginalTeacherIssueTagProps) {
  if (!issue) return null;

  const displayText = OriginalTeacherIssueLabelMap[issue];
  return <Badge variant="outline">{displayText}</Badge>;
}
